import { render, staticRenderFns } from "./driverSelect.vue?vue&type=template&id=5673053f&scoped=true&"
import script from "./driverSelect.vue?vue&type=script&lang=js&"
export * from "./driverSelect.vue?vue&type=script&lang=js&"
import style0 from "./driverSelect.vue?vue&type=style&index=0&id=5673053f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673053f",
  null
  
)

export default component.exports